<button class="open-button"
  [attr.aria-expanded]="showMenu"
  [attr.aria-label]="showMenu == true ? 'Close Menu' : 'Show Menu'"
  [class.init]="init == true ? 'init' : ''"
  aria-controls="primary-nav"
  (click)="toggleMenu()">
  <span></span>
  <span></span>
  <span></span>
</button>
<nav role="navigation" id="primary-nav" class="primary-nav" aria-label="Main Menu" cdkTrapFocus>
  <ul *ngIf="links.length">
    <li *ngFor="let i of links">
      <a [routerLink]="i.path" (click)="toggleMenu()" [class.active]="isActiveRoute(i.path)">{{ i.title }}</a>    
  </ul>
</nav>
